<span *ngIf="!disabled" class="tl-link" (click)="onLinkClick()" [ngClass]="{'tl-link-active' : active}">{{text}}</span>
<span *ngIf="disabled" class="tl-link-disabled">{{text}}</span>

